import { useTranslation } from 'react-i18next';
import { AppBar, AppBarContent } from '@commonClient2/components';
import { useAppLanguage } from '@hooks/index';
import { SessionStorageKeys } from '@enums/index';
import { safeJsonParse } from '@commonClient2/services/json';
import NavigationMenuIcon from '../NavigationMenuIcon';
import './AppBar.scss';

/**
 * @param {{
*  pageName: string;
*  pageSelected: number
* }} param0
*/
const ManagerAppBar = ({
    pageName,
    pageSelected,
}) => {
    const { t: tCommon } = useTranslation('shiftBidding', { keyPrefix: 'manager.common' });
    const appLanguage = useAppLanguage();

    const configs = {
        appEnvironment: sessionStorage.getItem('appEnvironment') || '',
        appVersion: sessionStorage.getItem('version') || '',
        isMultiLanguage: safeJsonParse(sessionStorage.getItem(SessionStorageKeys.isMultiLanguage)) || false,
    };

    return (
        <AppBar color="inherit">
            <div className="appBar-container">
                <div className="appBar-menu-icon-container">
                    <NavigationMenuIcon managerPageSelected={pageSelected} />
                </div>
                <div className="appBarContent-container">
                    <AppBarContent
                        name={tCommon('appName')}
                        pageName={pageName}
                        appLanguage={appLanguage}
                        configs={configs}
                    />
                </div>
            </div>
        </AppBar>
    );
};

export default ManagerAppBar;
